// Copyright (c) 2017 VMware, Inc. All Rights Reserved.
//
// Licensed under the Apache License, Version 2.0 (the "License");
// you may not use this file except in compliance with the License.
// You may obtain a copy of the License at
//
//    http://www.apache.org/licenses/LICENSE-2.0
//
// Unless required by applicable law or agreed to in writing, software
// distributed under the License is distributed on an "AS IS" BASIS,
// WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
// See the License for the specific language governing permissions and
// limitations under the License.

/**
 * Declare class for store the sign in data,
 * two prperties:
 *   principal: The username used to sign in
 *   password: The password used to sign in
 * 
 * @export
 * @class SignInCredential
 */

export class SignInCredential {
    principal: string;
    password: string;
}


// WEBPACK FOOTER //
// ./src/app/shared/sign-in-credential.ts